import React from 'react';
import { Button, Card, Form, Icon, message, Spin, Switch, Tooltip, Radio, Input, Row, Col, Select, Dropdown, Menu, Modal } from 'antd';
import CkInfoItem from "../../components/CkInfoItem";
import { fetchEvt } from "../../redux/actions/evt";
import { findSmssigns } from "../../services/sendEmailSms";
import { findAllocateFields } from "../../services/allot";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { inEditMode } from "../../redux/actions/global";
import { patchEventConfig } from "../../services/evt";
import { isValidity } from "../../services/global";
import classnames from 'classnames'
import evtConfigDes from './EvtConfigDes'
import lodash from "lodash"
import UserSmssignSetting from "../user/UserSmssignSetting";
import PurchaseServiceTips from "../PurchaseServiceTips";

const Option = Select.Option;
const TextArea = Input.TextArea;
const mapStateToPorps = state => {
    const cmEnums = state.cmEnums;
    return { cmEnums };
};
const mapDispatchToProps = dispatch => ({
    fetchEvt: bindActionCreators(fetchEvt, dispatch),
});


class EvtViewConfigForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            smssignsVisible: false,
            smsSigns: [],
            allocateFields: [],
            formLoading: false,
            validateAttendeeVisible: !this.props.evt.config.batchAttend,
            validateChannelVisible: this.props.evt.config.validateAttendee,
            allowUniqueFieldQuickCheckinVisible: this.props.evt.config.allowUniqueFieldCheckin,
            allowDirectCheckinVisible: this.props.evt.config.allowDirectCheckin,
            avatarMandatoryVisible: this.props.evt.config.faceOpen,
            directCheckinWxZeroInput: this.props.evt.config.directCheckinWxZeroInput,
            approveCheckinVisible: this.props.evt.config.approveCheckin,
        }
    }

    componentDidMount() {
        this.mounted = true;
        this.fetchSmsSigns();
        if (this.props.editableStatePropName == "checkinConfigEditable") {
            isValidity('WXCHECKINZEROINPUT', (vaild) => {
                this.setState({
                    validity: vaild
                })
            })
        }
        isValidity('FACECHECKIN', (vaild) => {
            this.setState({
                validityFace: vaild
            })
        })

        isValidity('REMOVELOGO', (vaild) => {
            this.setState({
                validityMember: vaild
            })
        })

    }

    componentWillUnmount() {
        this.mounted = false;
    }
    //查询短信签名
    fetchSmsSigns = () => {
        findSmssigns().then(res => {
            if (res.code === 200) {
                let _sms = res.data.filter(item => item.status === 'APPROVED')
                this.setState({ smsSigns: _sms })
            } else {
                message.error(res.msg,6);
            }
        })
        findAllocateFields({ eventId: this.props.evt.header.id }).then(res => {
            if (res.code === 200) {
                this.setState({
                    allocateFields: res.data,
                })
            }
        })
    }
    intoEdit = () => {
        this.props.editableChange(this.props.editableStatePropName, true)
    }
    cancelEdit = () => {
        this.props.editableChange(this.props.editableStatePropName, false)
    }
    save = () => {
        this.props.form.validateFieldsAndScroll((error, values) => {
            if (!error) {
                if (this.props.type == 'sendAttendSignInConfirm') {
                    if (values.formFieldId == '0' && values.sendAttendSignInConfirm) {
                        message.error('报名表单未添加手机或邮箱，参与人无法接受短信！')
                        return;
                    }
                }
                this.changeFormLoading(true);
                const that = this;
                if (this.props.editableStatePropName == "checkinConfigEditable") {
                    if (!this.state.validity) {
                        values.directCheckinWxZeroInput = false;
                    }
                }
                if (values.hasOwnProperty('onlyWxSignUp') && !this.state.validityMember) {
                    values.onlyWxSignUp = false;
                }
                if (values.hasOwnProperty('onlyWxCheckIn') && !this.state.validityMember) {
                    values.onlyWxCheckIn = false;
                }
                if (values.hasOwnProperty('faceOpen') && !this.state.validityFace) {
                    values.faceOpen = false;
                }
                if (values.hasOwnProperty('enableReplenishForm') && !this.state.validityFace) {
                    values.enableReplenishForm = false;
                }
                if(values.hasOwnProperty('enabledShareCode') && !this.state.validityFace){
                    values.enabledShareCode=false;
                }
                if(values.hasOwnProperty('enabledAttendeeUnbinding') && !this.state.validityFace){
                    values.enabledAttendeeUnbinding=false;
                }
                if(values.hasOwnProperty('enableInviteeStatistics') && !this.state.validityFace){
                    values.enableInviteeStatistics=false;
                }
                if (values.hasOwnProperty('allowAttendeeEditForm') && !this.state.validityFace) {
                    values.allowAttendeeEditForm = false;
                }
                if (values.hasOwnProperty('allowUniqueFieldLikeCheckin') && !this.state.validityFace) {
                    values.allowUniqueFieldLikeCheckin = false;
                }
                if (values.hasOwnProperty('enablePositionRecord') && !this.state.validityFace) {
                    values.enablePositionRecord = false;
                }
                if (values.hasOwnProperty('allowUniqueFieldCheckin')) {
                    values.allowUniqueFieldCheckin = !values.allowUniqueFieldCheckin
                }
                console.log(values)
                patchEventConfig(Object.assign({ id: this.props.evt.header.id }, values)).then(res => {
                    if (res.code == 200) {
                        message.info("更新成功!");
                        that.props.editableChange(this.props.editableStatePropName, false, true)
                    } else {
                        message.error(res.msg,6);
                    }
                }).catch(err => {
                    message.warn("访问异常");
                }).finally(() => {
                    that.changeFormLoading(false)
                })
            } else {
                console.log('error', error, values);
            }
        });
    }

    changeFormLoading = (loading) => {
        if (this.mounted) {
            this.setState({
                formLoading: loading
            })
        }
    }



    showSmsSignsModal = (flag) => {
        this.setState({ smssignsVisible: flag });
    }

    render() {
        const evt = this.props.evt;

        const { getFieldDecorator, getFieldValue, getFieldError } = this.props.form;

        const mobileOrEmail = evt.form.fields.filter(f => f.type == 'TEXT' && (lodash.startsWith(f.constraint, "mobile") || lodash.startsWith(f.constraint, "email")));
        const mobileOrEmailUnique = evt.form.fields.some(f => f.unique && (lodash.startsWith(f.constraint, "mobile") || lodash.startsWith(f.constraint, "email")));
        const insertMenuAttendee = (
            <Menu onClick={val => {
                // let _des = `${data.customMsg}${val.key}`;
                var fieldsValue = this.props.form.getFieldsValue();
                lodash.set(fieldsValue, 'attendNotifyMsg', `${fieldsValue.attendNotifyMsg}${val.key}`);
                this.props.form.setFieldsValue(
                    fieldsValue
                )
            }}>
                <Menu.Item key="{eventName}">活动名称</Menu.Item>
                <Menu.Item key=" https://qdj8.cn/{attendeeUri} ">确认函(签到码)</Menu.Item>
                {this.state.allocateFields.map(obj => {
                    return <Menu.Item key={obj.value}>{obj.name}</Menu.Item>
                })}
            </Menu>
        );

        const insertMenuAttendeeSignIn = (
            <Menu onClick={val => {
                // let _des = `${data.customMsg}${val.key}`;
                var fieldsValue = this.props.form.getFieldsValue();
                lodash.set(fieldsValue, 'attendSignInNotifyMsg', `${fieldsValue.attendSignInNotifyMsg}${val.key}`);
                this.props.form.setFieldsValue(
                    fieldsValue
                )
            }}>
                <Menu.Item key="{eventName}">活动名称</Menu.Item>
                {this.state.allocateFields.map(obj => {
                    return <Menu.Item key={obj.value}>{obj.name}</Menu.Item>
                })}
            </Menu>
        );
        const insertMenuSendAllotReceiver = (
            <Menu onClick={val => {
                // let _des = `${data.customMsg}${val.key}`;
                var fieldsValue = this.props.form.getFieldsValue();
                lodash.set(fieldsValue, 'allotReceiverNotifyMsg', `${fieldsValue.allotReceiverNotifyMsg}${val.key}`);
                this.props.form.setFieldsValue(
                    fieldsValue
                )
            }}>
                <Menu.Item key="{eventName}">活动名称</Menu.Item>
                {this.state.allocateFields.map(obj => {
                    return <Menu.Item key={obj.value}>{obj.name}</Menu.Item>
                })}
            </Menu>
        );

        const editableTools = this.props.editable ?
            <div className="evt-create-editable-tools">
                <Button type="primary" size="small" onClick={this.save}>保存</Button>
                <Button type="primary" size="small" ghost onClick={this.cancelEdit}>放弃</Button>
            </div>
            :
            <div className="evt-create-editable-tools" onClick={this.intoEdit}>
                <Button type="primary" size="small" ghost>编辑</Button>
            </div>

        const configArr = this.props.confDesArr;
        return (
            <Form>
                <Spin spinning={this.state.formLoading}>
                    <Card bodyStyle={{ padding: "16px" }}>
                        {editableTools}
                        {
                            configArr.map((conf, index) => {
                                let _disabled=false;
                                let style = {};
                                if (conf.fieldName === "validateAttendee") {
                                    _disabled = !mobileOrEmailUnique;
                                    style = { display: this.state.validateAttendeeVisible ? 'block' : 'none' };
                                } else if (conf.fieldName === "avatarMandatory") {
                                    style = { display: !this.state.avatarMandatoryVisible ? 'block' : 'none' };
                                } else if (conf.fieldName === "allowDirectCheckin") {
                                    style = { display: !this.state.approveCheckinVisible ? 'block' : 'none' };
                                } else if (conf.fieldName === "allowUniqueFieldCheckin") {
                                    _disabled = !mobileOrEmailUnique;
                                    style = { display: !this.state.approveCheckinVisible && !this.state.directCheckinWxZeroInput ? 'block' : 'none' };
                                } else if (conf.fieldName === "allowUniqueFieldQuickCheckin" || conf.fieldName === "allowUniqueFieldLikeCheckin") {
                                    style = { display: this.state.allowUniqueFieldQuickCheckinVisible && !this.state.approveCheckinVisible ? "block" : "none" }
                                } else if (conf.fieldName === "enableFindTicketCaptcha") {
                                    _disabled = !mobileOrEmailUnique;
                                } 
                                const ckinfo = <CkInfoItem
                                    // style={{display:conf.fieldName == "allowUniqueFieldCheckin" ? 'none' : 'block'}}
                                    style={style}
                                    key={`${conf.fieldName}${index}`}
                                    label={
                                        <div>
                                            {conf.name}
                                            <Tooltip placement="bottom" overlayClassName='overlay-image'
                                                mouseEnterDelay={0.3} title={
                                                    <div style={{ overflow: 'auto' }} dangerouslySetInnerHTML={{ __html: conf.help }}></div>
                                                }>
                                                <span title="" style={{ marginLeft: "3px" }}><Icon
                                                    type="question-circle-o" /></span>
                                            </Tooltip>
                                        </div>
                                    }
                                    contentIndent={false}
                                >

                                    {
                                        this.props.editable ?
                                            getFieldDecorator(conf.fieldName, {
                                                initialValue: conf.fieldName === "allowUniqueFieldCheckin" ? !evt.config[conf.fieldName] : evt.config[conf.fieldName],
                                                valuePropName: 'checked',
                                                rules: [{ required: true }],
                                            })(
                                                <Switch 
                                                    disabled={_disabled}
                                                    checkedChildren={conf.switch[0]}
                                                    unCheckedChildren={conf.switch[1]}
                                                    onChange={(checked) => {
                                                        if (conf.fieldName === "batchAttend") {
                                                            this.setState({
                                                                validateAttendeeVisible: !checked,
                                                            }, () => {
                                                                this.props.form.setFieldsValue({
                                                                    'validateAttendee': false,
                                                                });
                                                                this.setState({ validateChannelVisible: this.props.form.getFieldValue("validateAttendee") });
                                                            })

                                                        } else if (conf.fieldName === "validateAttendee") {
                                                            this.setState({
                                                                validateChannelVisible: checked
                                                            })
                                                        } else if (conf.fieldName === "allowDirectCheckin") {
                                                            this.setState({
                                                                allowDirectCheckinVisible: checked
                                                            })
                                                            var fieldsValue = this.props.form.getFieldsValue();
                                                            if (!checked) {
                                                                lodash.set(fieldsValue, evtConfigDes.directCheckinWxZeroInput.fieldName, false);
                                                            } else {
                                                                // lodash.set(fieldsValue, evtConfigDes.allowUniqueFieldCheckin.fieldName, false);
                                                            }
                                                            this.props.form.setFieldsValue(
                                                                fieldsValue
                                                            )

                                                        } else if (conf.fieldName === "faceOpen") {
                                                            if (!this.state.validityFace && checked) {
                                                                this.setState({
                                                                    isMember: false
                                                                }, () => this.pstView.show())
                                                            } else {
                                                                this.setState({
                                                                    avatarMandatoryVisible: checked
                                                                })
                                                            }

                                                        } else if (conf.fieldName === "enableReplenishForm") {
                                                            if (!this.state.validityFace && checked) {
                                                                this.setState({
                                                                    isMember: false
                                                                }, () => this.pstView.show())
                                                            }

                                                        } else if (conf.fieldName === "allowUniqueFieldLikeCheckin") {
                                                            if (!this.state.validityFace && checked) {
                                                                this.setState({
                                                                    isMember: false
                                                                }, () => this.pstView.show())
                                                            }

                                                        } else if (conf.fieldName === "allowAttendeeEditForm") {
                                                            if (!this.state.validityFace && checked) {
                                                                this.setState({
                                                                    isMember: false
                                                                }, () => this.pstView.show())
                                                            }
                                                            
                                                        } else if (conf.fieldName === "enabledShareCode") {
                                                            if (!this.state.validityFace && checked) {
                                                                this.setState({
                                                                    isMember: false
                                                                }, () => this.pstView.show())
                                                            }

                                                        }else if (conf.fieldName === "enabledAttendeeUnbinding") {
                                                            if (!this.state.validityFace && checked) {
                                                                this.setState({
                                                                    isMember: false
                                                                }, () => this.pstView.show())
                                                            }
                                                            
                                                        }else if (conf.fieldName === "enableInviteeStatistics") {
                                                            if (!this.state.validityFace && checked) {
                                                                this.setState({
                                                                    isMember: false
                                                                }, () => this.pstView.show())
                                                            }

                                                        }else if (conf.fieldName === "enablePositionRecord") {
                                                            if (!this.state.validityFace && checked) {
                                                                this.setState({
                                                                    isMember: false
                                                                }, () => this.pstView.show())
                                                            }

                                                        } else if (conf.fieldName === "onlyWxSignUp") {
                                                            if (!this.state.validityMember && checked) {
                                                                this.setState({
                                                                    isMember: true
                                                                }, () => this.pstView.show())
                                                            }

                                                        } else if (conf.fieldName === "onlyWxCheckIn") {
                                                            if (!this.state.validityMember && checked) {
                                                                this.setState({
                                                                    isMember: true
                                                                }, () => this.pstView.show())
                                                            }

                                                        } else if (conf.fieldName === "approveCheckin") {
                                                            var fieldsValue = this.props.form.getFieldsValue();
                                                            this.setState({
                                                                approveCheckinVisible: checked
                                                            })
                                                            if (checked) {
                                                                lodash.set(fieldsValue, evtConfigDes.allowDirectCheckin.fieldName, !checked);
                                                                lodash.set(fieldsValue, evtConfigDes.directCheckinWxZeroInput.fieldName, !checked);
                                                            }
                                                            this.props.form.setFieldsValue(
                                                                fieldsValue
                                                            )
                                                        } else if (conf.fieldName === "allowUniqueFieldCheckin") {
                                                            this.setState({
                                                                allowUniqueFieldQuickCheckinVisible: !checked
                                                            }, () => {
                                                                var fieldsValue = this.props.form.getFieldsValue();
                                                                lodash.set(fieldsValue, evtConfigDes.allowUniqueFieldQuickCheckin.fieldName, !checked);
                                                                this.props.form.setFieldsValue(
                                                                    fieldsValue
                                                                )
                                                            })
                                                        }
                                                    }}
                                                />
                                            )
                                            :
                                            <span className={classnames("evt-config-item", {
                                                'mdc-text-green': conf.fieldName === "allowUniqueFieldCheckin" ? !evt.config[conf.fieldName] : evt.config[conf.fieldName],
                                                'text-error': conf.fieldName === "allowUniqueFieldCheckin" ? evt.config[conf.fieldName] : !evt.config[conf.fieldName]
                                            })}>
                                                {conf.fieldName === "allowUniqueFieldCheckin" ?
                                                    (!evt.config[conf.fieldName] ? conf.switch[0] : conf.switch[1])
                                                    :
                                                    (evt.config[conf.fieldName] ? conf.switch[0] : conf.switch[1])
                                                }
                                            </span>
                                    }

                                </CkInfoItem>

                                if (conf.fieldName === "validateAttendee") {
                                    const ckinfo2 = <CkInfoItem
                                        key={`${conf.fieldName}1dsf${index}`}
                                        style={{ display: this.state.validateChannelVisible ? "block" : "none" }}
                                        label={
                                            <div>
                                                报名验证渠道
                                            </div>
                                        }
                                        contentIndent={false}
                                    >

                                        {
                                            this.props.editable ?
                                                getFieldDecorator(`validateChannel`, {
                                                    initialValue: evt.config.validateChannel ? evt.config.validateChannel : "SMS",
                                                    rules: [{ required: true }],
                                                })(
                                                    <Radio.Group>
                                                        {
                                                            Object.values(this.props.cmEnums.data.ValidateChannel).map((item, index) => {
                                                                return <Radio.Button value={item.enumName.toString()}
                                                                    key={`event-mode-${index}`}>{item.enumDesc}</Radio.Button>
                                                            })
                                                        }
                                                    </Radio.Group>
                                                )
                                                :
                                                <span className={classnames("evt-config-item mdc-text-green")}>
                                                    {evt.config.validateChannel ? this.props.cmEnums.data.ValidateChannel[evt.config.validateChannel].enumDesc : this.props.cmEnums.data.ValidateChannel["SMS"].enumDesc}
                                                </span>
                                        }

                                    </CkInfoItem>
                                    return <div key={`${conf.fieldName}1ddfdf3453sf${index}`}>
                                        {ckinfo}
                                        {ckinfo2}
                                    </div>
                                } else if (conf.fieldName == "allowDirectCheckin") {
                                    const ckinfo2 = <div key={`cfvdfg345v7da${index}`} style={{ display: this.state.allowDirectCheckinVisible && !this.state.approveCheckinVisible ? "block" : "none" }}>
                                        <CkInfoItem
                                            style={{ display: !this.state.directCheckinWxZeroInput ? "block" : "none" }}
                                            label={
                                                <div>
                                                    {evtConfigDes.directCheckinUniqueFieldOnly.name}
                                                    <Tooltip placement="bottom" overlayClassName='overlay-image' mouseEnterDelay={0.3} title={
                                                        <div dangerouslySetInnerHTML={{ __html: evtConfigDes.directCheckinUniqueFieldOnly.help }}>
                                                        </div>

                                                    }>
                                                        <span title="" style={{ marginLeft: "3px" }}><Icon
                                                            type="question-circle-o" /></span>
                                                    </Tooltip>
                                                </div>
                                            }
                                            contentIndent={false}
                                        >

                                            {
                                                this.props.editable ?
                                                    getFieldDecorator(evtConfigDes.directCheckinUniqueFieldOnly.fieldName, {
                                                        initialValue: evt.config.eventMode == 'BYREGISTER' ? evt.config[evtConfigDes.directCheckinUniqueFieldOnly.fieldName] : true,
                                                        rules: [{ required: true }],
                                                    })(
                                                        <Radio.Group disabled={evt.config.eventMode == 'BYREGISTER' ? false : true}>
                                                            <Radio.Button value={false} >补充信息</Radio.Button>
                                                            <Radio.Button value={true} >唯一字段</Radio.Button>
                                                        </Radio.Group>
                                                    )
                                                    :
                                                    <span className={classnames("evt-config-item", {
                                                        'mdc-text-green': true,
                                                        // 'text-error': !evt.config[evtConfigDes.directCheckinUniqueFieldOnly.fieldName]
                                                    })}>
                                                        {evt.config[evtConfigDes.directCheckinUniqueFieldOnly.fieldName] ? evtConfigDes.directCheckinUniqueFieldOnly.switch[1] : evtConfigDes.directCheckinUniqueFieldOnly.switch[0]}
                                                    </span>
                                            }

                                        </CkInfoItem>

                                        <CkInfoItem
                                            style={{ display: !this.state.approveCheckinVisible ? "block" : "none" }}
                                            label={
                                                <div>
                                                    {evtConfigDes.directCheckinWxZeroInput.name}
                                                    <Tooltip placement="bottom" overlayClassName='overlay-image' mouseEnterDelay={0.3} title={
                                                        <div dangerouslySetInnerHTML={{ __html: evtConfigDes.directCheckinWxZeroInput.help }}>
                                                            {/*<img style={{width:450}} src={evtConfigDes.directCheckinWxZeroInput.url}/>*/}
                                                        </div>

                                                    }>
                                                        <span title="" style={{ marginLeft: "3px" }}><Icon
                                                            type="question-circle-o" /></span>
                                                    </Tooltip>
                                                </div>
                                            }
                                            contentIndent={false}
                                        >

                                            {
                                                this.props.editable ?
                                                    getFieldDecorator(evtConfigDes.directCheckinWxZeroInput.fieldName, {
                                                        initialValue: evt.config[evtConfigDes.directCheckinWxZeroInput.fieldName],
                                                        valuePropName: 'checked',
                                                        rules: [{ required: false }],
                                                    })(
                                                        <Switch checkedChildren={evtConfigDes.directCheckinWxZeroInput.switch[0]} unCheckedChildren={evtConfigDes.directCheckinWxZeroInput.switch[1]}
                                                            onChange={checked => {
                                                                if (!this.state.validity) {
                                                                    if (checked) {
                                                                        this.setState({
                                                                            isMember: false
                                                                        }, () => this.pstView.show())
                                                                    }

                                                                } else {
                                                                    this.setState({ directCheckinWxZeroInput: checked })
                                                                }

                                                                var fieldsValue = this.props.form.getFieldsValue();
                                                                if (checked) {
                                                                    lodash.set(fieldsValue, evtConfigDes.allowUniqueFieldCheckin.fieldName, false);
                                                                } else {
                                                                    // lodash.set(fieldsValue, evtConfigDes.allowUniqueFieldCheckin.fieldName, false);
                                                                }
                                                                this.props.form.setFieldsValue(
                                                                    fieldsValue
                                                                )
                                                            }}
                                                        />
                                                    )
                                                    :
                                                    <span className={classnames("evt-config-item", {
                                                        'mdc-text-green': evt.config[evtConfigDes.directCheckinWxZeroInput.fieldName],
                                                        'text-error': !evt.config[evtConfigDes.directCheckinWxZeroInput.fieldName]
                                                    })}>
                                                        {evt.config[evtConfigDes.directCheckinWxZeroInput.fieldName] ? evtConfigDes.directCheckinWxZeroInput.switch[0] : evtConfigDes.directCheckinWxZeroInput.switch[1]}
                                                    </span>
                                            }

                                        </CkInfoItem>
                                    </div>
                                    return <div key={`${conf.fieldName}1ddfddxcdf3453sf${index}`}>
                                        {ckinfo}
                                        {ckinfo2}
                                    </div>
                                } else if (conf.fieldName == "enabledShareCode") {
                                    const ckinfo2 = (
                                        <CkInfoItem label='邀请码显示名称' contentIndent={false}>
                                            {
                                                this.props.editable ?
                                                    getFieldDecorator(`shareCodeName`, {
                                                        initialValue: evt.config.shareCodeName,
                                                        rules: [{ required: true, message: '必填项' }],
                                                    })(
                                                        <Input placeholder="自定义显示名称，如：特约码，会员编号等"/>
                                                    )
                                                    :
                                                    <span>{evt.config.shareCodeName}</span>
                                            }
                                        </CkInfoItem>
                                    )
                                    return <div key={`${conf.fieldName}1ddfddxcdf3453sf${index}`}>
                                        {ckinfo}
                                        {ckinfo2}
                                    </div>
                                } else {
                                    return ckinfo;
                                }




                            })
                        }
                        {this.props.type == 'sendAttendConfirm' && this.props.editable ?
                            <CkInfoItem
                                label={
                                    <div>
                                        信息通知(测试请用免审默认短信，默认签名）
                                    </div>
                                }
                                contentIndent={false}
                            >
                                <div>
                                    <Row>
                                        <Col span={12}>
                                            <Dropdown overlay={insertMenuAttendee}>
                                                <Button style={{ marginRight: 4 }}>
                                                    插入内容 <Icon type="down" />
                                                </Button>
                                            </Dropdown>
                                            <Button onClick={() => {
                                                var fieldsValue = this.props.form.getFieldsValue();
                                                lodash.set(fieldsValue, 'attendNotifyMsg', '请您准时出席{eventName}，签到码 http://qdj8.cn/{attendeeUri}');
                                                lodash.set(fieldsValue, 'attendNotifySign', '0');
                                                this.props.form.setFieldsValue(
                                                    fieldsValue
                                                )
                                            }}>
                                                点击恢复默认短信
                                            </Button>
                                        </Col>
                                        <Col span={12} style={{ textAlign: 'right' }}>
                                            <a href="#" onClick={() => this.showSmsSignsModal(true)}>自定义 </a>
                                            <span>签名：</span>
                                            {
                                                getFieldDecorator(`attendNotifySign`, {
                                                    initialValue: evt.config.attendNotifySign,
                                                    rules: [{ required: false }],
                                                })(
                                                    <Select style={{ width: 100, marginRight: 4 }}
                                                        placeholder="请选择"
                                                    >
                                                        {this.state.smsSigns.map((obj, index) => {
                                                            return <Option key={index} value={obj.id}>{obj.sign}</Option>
                                                        })}
                                                    </Select>
                                                )
                                            }
                                        </Col>
                                    </Row>


                                    <div>
                                        {
                                            getFieldDecorator(`attendNotifyMsg`, {
                                                initialValue: evt.config.attendNotifyMsg ? evt.config.attendNotifyMsg : '请您准时出席{eventName}，签到码 http://qdj8.cn/{attendeeUri}',
                                                rules: [{ required: false }],
                                            })(
                                                <TextArea style={{ marginTop: 8 }}
                                                    ref={node => this.textareVal = node}
                                                    placeholder=''
                                                    rows={4} />
                                            )
                                        }

                                    </div>
                                </div>
                            </CkInfoItem>
                            :
                            ''}

                        {this.props.type == 'sendAttendSignInConfirm' && this.props.editable ?
                            <CkInfoItem
                                label={
                                    <div>
                                        信息通知(测试请用免审默认短信，默认签名）
                                    </div>
                                }
                                contentIndent={false}
                            >
                                <div>
                                    <Row>
                                        <Col span={16}>
                                            <Dropdown overlay={insertMenuAttendeeSignIn}>
                                                <Button style={{ marginRight: 4 }}>
                                                    插入内容 <Icon type="down" />
                                                </Button>
                                            </Dropdown>
                                            {
                                                getFieldDecorator(`formFieldId`, {
                                                    initialValue: evt.config.formFieldId == '0' && mobileOrEmail.length > 0 ? mobileOrEmail[0].id : evt.config.formFieldId,
                                                    rules: [{ required: false }],
                                                })(
                                                    <Select style={{ width: 100, marginRight: 4 }}
                                                        placeholder="接收号码"
                                                    >
                                                        <Option disabled value={'0'}>请选择</Option>
                                                        {evt.form.fields.filter(f => f.type == 'TEXT' && (lodash.startsWith(f.constraint, "mobile") || lodash.startsWith(f.constraint, "email"))).map((obj, index) => {
                                                            return <Option key={index} value={obj.id}>{obj.name}</Option>
                                                        })}
                                                    </Select>
                                                )
                                            }
                                            <Button onClick={() => {
                                                var fieldsValue = this.props.form.getFieldsValue();
                                                lodash.set(fieldsValue, 'attendSignInNotifyMsg', '感谢您出席{eventName}，点击查看信息 http://qdj8.cn/{checkinUri}');
                                                lodash.set(fieldsValue, 'attendSignInNotifySign', '0');
                                                this.props.form.setFieldsValue(
                                                    fieldsValue
                                                )
                                            }}>
                                                点击恢复默认短信
                                            </Button>
                                        </Col>
                                        <Col span={8} style={{ textAlign: 'right' }}>
                                            <a href="#" onClick={() => this.showSmsSignsModal(true)}>自定义 </a>
                                            <span>签名：</span>
                                            {
                                                getFieldDecorator(`attendSignInNotifySign`, {
                                                    initialValue: evt.config.attendSignInNotifySign,
                                                    rules: [{ required: false }],
                                                })(
                                                    <Select style={{ width: 100, marginRight: 4 }}
                                                        placeholder="请选择"
                                                    >
                                                        {this.state.smsSigns.map((obj, index) => {
                                                            return <Option key={index} value={obj.id}>{obj.sign}</Option>
                                                        })}
                                                    </Select>
                                                )
                                            }
                                        </Col>
                                    </Row>


                                    <div>
                                        {
                                            getFieldDecorator(`attendSignInNotifyMsg`, {
                                                initialValue: evt.config.attendSignInNotifyMsg ? evt.config.attendSignInNotifyMsg : '感谢您出席{eventName}，点击查看信息 http://qdj8.cn/{checkinUri}',
                                                rules: [{ required: false }],
                                            })(
                                                <TextArea style={{ marginTop: 8 }}
                                                    ref={node => this.textareVal = node}
                                                    placeholder=''
                                                    rows={4} />
                                            )
                                        }

                                    </div>
                                </div>
                            </CkInfoItem>
                            :
                            ''}

                        {this.props.type == 'sendAllotReceiver' && this.props.editable ?
                            <CkInfoItem
                                label={
                                    <div>
                                        信息通知(测试请用免审默认短信，默认签名）
                                    </div>
                                }
                                contentIndent={false}
                            >
                                <div>
                                    <Row>
                                        <Col span={12}>
                                            <Dropdown overlay={insertMenuSendAllotReceiver}>
                                                <Button style={{ marginRight: 4 }}>
                                                    插入内容 <Icon type="down" />
                                                </Button>
                                            </Dropdown>
                                            <Button onClick={() => {
                                                var fieldsValue = this.props.form.getFieldsValue();
                                                lodash.set(fieldsValue, 'allotReceiverNotifyMsg', '您的{attendeeName}已到{checkinpointName}');
                                                lodash.set(fieldsValue, 'allotReceiverNotifySign', '0');
                                                this.props.form.setFieldsValue(
                                                    fieldsValue
                                                )
                                            }}>
                                                点击恢复默认短信
                                            </Button>
                                        </Col>
                                        <Col span={12} style={{ textAlign: 'right' }}>
                                            <a href="#" onClick={() => this.showSmsSignsModal(true)}>自定义 </a>
                                            <span>签名：</span>
                                            {
                                                getFieldDecorator(`allotReceiverNotifySign`, {
                                                    initialValue: evt.config.allotReceiverNotifySign,
                                                    rules: [{ required: false }],
                                                })(
                                                    <Select style={{ width: 100, marginRight: 4 }}
                                                        placeholder="请选择"
                                                    >
                                                        {this.state.smsSigns.map((obj, index) => {
                                                            return <Option key={index} value={obj.id}>{obj.sign}</Option>
                                                        })}
                                                    </Select>
                                                )
                                            }
                                        </Col>
                                    </Row>


                                    <div>
                                        {
                                            getFieldDecorator(`allotReceiverNotifyMsg`, {
                                                initialValue: evt.config.allotReceiverNotifyMsg ? evt.config.allotReceiverNotifyMsg : '您的{attendeeName}已到{checkinpointName}',
                                                rules: [{ required: false }],
                                            })(
                                                <TextArea style={{ marginTop: 8 }}
                                                    ref={node => this.textareVal = node}
                                                    placeholder=''
                                                    rows={4} />
                                            )
                                        }

                                    </div>
                                </div>
                            </CkInfoItem>
                            :
                            ''}

                    </Card>
                </Spin>
                <Modal
                    bodyStyle={{ paddingTop: 10 }}
                    width={800}
                    title="短信签名管理"
                    visible={this.state.smssignsVisible}
                    onCancel={() => this.showSmsSignsModal(false)}
                    footer={null}
                >
                    <UserSmssignSetting />
                </Modal>
                <PurchaseServiceTips
                    ref={(pst) => {
                        this.pstView = pst
                    }}
                    member={this.state.isMember ? 'MEMBER' : 'SENIORMEMBER'}

                />
            </Form>
        )
    }
}


EvtViewConfigForm.contextTypes = {}

EvtViewConfigForm.defaultProps = {
    evt: {},
    editableStatePropName: null,
    confDesArr: [],
    editable: false,
    editableChange: (editable, dataChanged = false) => null,
}

EvtViewConfigForm.propTypes = {}


export default connect(mapStateToPorps, mapDispatchToProps)(Form.create()(EvtViewConfigForm));


// WEBPACK FOOTER //
// ./src/containers/evt/EvtViewConfigForm.jsx